module.exports = __webpack_public_path__ + "assets/img/icon_parent_child_dialogue.a2ade2a4.png";